// extracted by mini-css-extract-plugin
export default {"sheet":"PhotosUploadModal_sheet__dTrOQ","dragHandleBar":"PhotosUploadModal_dragHandleBar__+pEWE","modalBody":"PhotosUploadModal_modalBody__Wahzu"};